export default require('../otherChains/taiko').default.rpcUrls.default.http[0]